import React, { StatelessComponent } from 'react';
import classNames from 'classnames';
import styles from './illustration.styl';

export interface IllustrationSizeProps {
  widht: number | 'auto';
  height: number | 'auto';
}

interface IllustrationWithSourceProps extends IllustrationSizeProps {
  src: string;
}

export type IllustrationComponentSizeProps = StatelessComponent<IllustrationSizeProps>;

export const Illustration: StatelessComponent<IllustrationWithSourceProps> = ({
  src,
  height,
  widht,
}: IllustrationWithSourceProps) => {
  return (
    <img
      className={classNames(styles.root)}
      style={{ width: widht || 'auto', height: height || 'auto' }}
      src={src}
    />
  );
};
